import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { CodedProperty, Optional } from "sprint-common-web";

import { ContentReferenceType } from "../../../../common/types/ContentReferenceType";
import { useAssociateContentFormContext } from "../context/useAssociateContentFormContext";
import { ContentAssociationDetails } from "../types/ContentAssociationDetails";
import { ContentAssociationFormState } from "../types/ContentAssociationFormState";

interface ContentAssociationAncillarySelectionOpts {
    airlines: CodedProperty[];
    versionType: Optional<string>;
}

export const useContentAssociationAncillaryContentForm = () => {
    const { contentDetails, setValidationResult } = useAssociateContentFormContext();
    const { setValue } = useFormContext<ContentAssociationFormState>();

    const [opts, setOpts] = useState<ContentAssociationAncillarySelectionOpts>(getDefaultOptions(contentDetails));

    const selectAirline = () => {
        if (!contentDetails || contentDetails.type !== ContentReferenceType.Ancillary) return;

        setOpts({ ...opts, versionType: contentDetails.version.type.name });
        setValidationResult(undefined);
    };

    const clearAirline = () => {
        setOpts({
            ...opts,
            versionType: undefined
        });

        setValidationResult(undefined);
    };

    const init = () => {
        if (!contentDetails) return;

        setOpts(getDefaultOptions(contentDetails));

        if (contentDetails.type === ContentReferenceType.Ancillary) {
            setValue("versionIds", [contentDetails.version.id]);
        }
    };

    return {
        init,
        opts,
        selections: {
            selectAirline,
            clearAirline
        }
    };
};

const getDefaultOptions = (contentDetails?: ContentAssociationDetails): ContentAssociationAncillarySelectionOpts => {
    if (!contentDetails || contentDetails.type !== ContentReferenceType.Ancillary) {
        return {
            airlines: [],
            versionType: undefined
        };
    }

    return {
        airlines: contentDetails.version.airlines,
        versionType: contentDetails.version.type.name
    };
};
